import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { StateRequirementNSwagMigrationService } from '../../api/migration/state-requirement-nswag-migration.service';
import { ProfileRequirement } from '../../models/profile-requirements.model';
import {
    getAvailableStatesForRequirements,
    getAvailableStatesForRequirementsFailure,
    getAvailableStatesForRequirementsSuccess,
    getStateGlobalRequirements,
    getStateGlobalRequirementsFailure,
    getStateGlobalRequirementsSuccess
} from '../actions/state-requirement.actions';

@Injectable()
export class StateRequirementEffects {
    constructor(private readonly _actions$: Actions, private readonly _service: StateRequirementNSwagMigrationService) {}

    getAvailableStatesForRequirements$ = createEffect(() =>
        this._actions$.pipe(
            ofType(getAvailableStatesForRequirements),
            switchMap((action) =>
                this._service.getAvailableStateForRequirements(action.filter).pipe(
                    map((result) => getAvailableStatesForRequirementsSuccess({ states: result })),
                    catchError((result) => of(getAvailableStatesForRequirementsFailure({ error: result.message })))
                )
            )
        )
    );

    getGlobalStatesRequirements$ = createEffect(() =>
        this._actions$.pipe(
            ofType(getStateGlobalRequirements),
            switchMap((action) =>
                this._service.getStateGlobalRequirements(action.stateId, action.filter).pipe(
                    map((result: ProfileRequirement[]) => getStateGlobalRequirementsSuccess({ requirements: result })),
                    catchError((result) => of(getStateGlobalRequirementsFailure({ error: result.message })))
                )
            )
        )
    );
}
